// config.js
const config = {
  apiUrl: '/api',
};

export default config;
